import { render, staticRenderFns } from "./CreateDeliveryBillDialog.vue?vue&type=template&id=06b4cc2f"
import script from "./CreateDeliveryBillDialog.vue?vue&type=script&lang=js"
export * from "./CreateDeliveryBillDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateDeliveryBillDialog.vue?vue&type=style&index=0&id=06b4cc2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports